import styled from 'styled-components/macro'

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.support_error};
  color: ${({ theme }) => theme.colors.text_inverse};
  position: sticky;
  top: 0;
  z-index: 2;
  width: 100%;
  box-sizing: border-box;
  padding: 1.2rem 1.8rem;
  text-align: center;
  font-size: ${({ theme }) => theme.fontSizes.s};
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  line-height: ${({ theme }) => theme.lineHeights.default};
`
